<div class="generic-modal-root" >

    <div class="row-padding">
      <div class="row" style="margin-top: 0;">
          <h3 style="text-align: center; font-weight: 300; width: 100%;">Device Info</h3>
          <table class="account-table">  
            <tr>         
                <td class="account-name" >
                    <span>Device Name: </span>
                </td>
                <td style="padding: 15px; text-align:center;">
                  <span>{{ device.name }}</span>
                </td>
            </tr>    
            <tr>         
              <td class="account-name" >
                  <span>Type: </span>
              </td>
              <td style="padding: 15px; text-align:center;">
                <span>{{ device.type }}</span>
              </td>
          </tr>       
          <tr>         
            <td class="account-name" >
                <span>Model: </span>
            </td>
            <td style="padding: 15px; text-align:center;">
              <span>{{ device.model }}</span>
            </td>
        </tr>      
        <tr>         
          <td class="account-name" >
              <span>Identifier: </span>
          </td>
          <td style="padding: 15px; text-align:center;">
            <span>{{ device.identifier }}</span>
          </td>
      </tr>   
      <tr>         
        <td class="account-name" >
            <span>Date Created: </span>
        </td>
        <td style="padding: 15px; text-align:center;">
          <span>{{ device.dateCreated | date }}</span>
        </td>
    </tr>   
        </table>
      </div>
    </div>
  
  
    <div style="height: 45px;">
      <button (click)="close()" class="btn btn-danger" style="margin-left: 15px;float: right;margin-top: 10px;">Close</button>
    </div>
  </div> 